import "./i18n"
import App from "./components/App.svelte"

import { baseURL } from "./configs/config"
import { hydrate, mount } from "svelte"
import { location } from "./store"
import { get } from "svelte/store"

const publishLocation = (_p?: string) => {
    let _s: string
    let _h: string
    if (_p) {
        const parts = _p.split("#")
        _p = parts.shift()
        _h = parts.join()
        if (_h) _h = "#" + _h

        const parts2 = _p.split("?")
        _p = parts2.shift()
        _s = parts2.join()
        if (_s) _s = "?" + _s
    }

    const newLocation = {
        path: _p || (typeof window !== "undefined" && window.location?.pathname),
        search: _p ? _s : typeof window !== "undefined" && window.location?.search,
        hash: _p ? _h : typeof window !== "undefined" && window.location?.hash,
        push: !!_p,
        pop: !_p,
        categoryPath: "",
        url: "",
    }
    newLocation.url = `${baseURL}${newLocation.path}${newLocation.search ? newLocation.search : ""}`
    newLocation.categoryPath = newLocation.path.replace(/\/[^_\/]+_[^\/]+$/, "")
    const currentLocation = get(location)
    const hasLocationChanged =
        currentLocation.path !== newLocation.path ||
        currentLocation.search !== newLocation.search ||
        currentLocation.hash !== newLocation.hash ||
        currentLocation.url !== newLocation.url ||
        currentLocation.categoryPath !== newLocation.categoryPath ||
        currentLocation.push !== newLocation.push ||
        currentLocation.pop !== newLocation.pop

    if (!hasLocationChanged) return

    location.set(newLocation)
}

if (typeof history !== "undefined") {
    if (typeof Proxy !== "undefined") {
        // modern browser
        const historyApply = (target: any, thisArg: any, argumentsList: any[]) => {
            let url = argumentsList && argumentsList.length >= 3 && argumentsList[2]
            if (url) {
                try {
                    const parsedUrl = new URL(url, window.location.origin)
                    url = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash
                } catch (e) {}
            }
            publishLocation(url)
            return Reflect.apply(target, thisArg, argumentsList)
        }

        history.pushState = new Proxy(history.pushState, {
            apply: historyApply,
        })

        history.replaceState = new Proxy(history.replaceState, {
            apply: historyApply,
        })
    } else {
        // ie11
        const pushStateFn = history.pushState
        const replaceStateFn = history.replaceState

        history.pushState = function (data: any, title: string, url?: string | URL) {
            let path
            if (url) {
                try {
                    const parsedUrl = new URL(url, window.location.origin)
                    path = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash
                } catch (e) {}
            }
            publishLocation(path)
            return Reflect.apply(pushStateFn, history, [data, title, url])
        }
        history.replaceState = function (data: any, title: string, url?: string | URL) {
            let path
            if (url) {
                try {
                    const parsedUrl = new URL(url, window.location.origin)
                    path = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash
                } catch (e) {}
            }
            publishLocation(path)
            return Reflect.apply(replaceStateFn, history, [data, title, url])
        }
    }
} // else ssr -> no history handling

typeof window !== "undefined" &&
    window.addEventListener("popstate", (event) => {
        publishLocation()
    })
let appContainer = document?.getElementById("appContainer")

function normalizeRootPath() {
    if (typeof window === "undefined") return
    if (window.location.pathname !== "/") return

    const targetPath = `/de${window.location.search || ""}${window.location.hash || ""}`
    window.history.replaceState(null, "", targetPath)
    publishLocation("/de")
}

// SSR-generierte dynamische Head-Elemente vor der Hydration entfernen,
// damit Svelte 5 svelte:head sie sauber neu erstellt ohne Duplikate.
function removeSSRHeadElements() {
    if (typeof document === "undefined") return
    const selectors = [
        'meta[name="description"]',
        'meta[name="keywords"]',
        'meta[name="robots"]',
        'meta[property^="og:"]',
        'meta[name^="twitter:"]',
        'link[rel="canonical"]',
        'link[rel="alternate"][hreflang]',
    ]
    document.head.querySelectorAll(selectors.join(", ")).forEach((el) => el.remove())
}

const bootApp = () => {
    if (!appContainer) return null

    normalizeRootPath()
    removeSSRHeadElements()

    try {
        return hydrate(App, { target: appContainer })
    } catch (error) {
        console.warn("Hydration failed, falling back to client mount", error)
        appContainer.innerHTML = ""
        return mount(App, { target: appContainer })
    }
}

const app = bootApp()

export default app
